export default __webpack_public_path__ + "static/media/noPosterSmall.ea2ad102.png";